/**
 * Test ID utilities for Separator component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for separator elements
 * @param orientation - Separator orientation (horizontal or vertical)
 * @returns Test ID string
 */
export const setSeparatorTestId = (orientation: "horizontal" | "vertical" = "horizontal"): string =>
  generateTestId("Separator", orientation);
